module.exports = __webpack_public_path__ + "SCTProfessional/static/dist/img/banner_demo.926fb2b1.png";